<template>
  <div class="max-w-lg m-auto my-16">

    <BrokerpadLogo />

    <div class="p-8 bg-white mt-6 rounded shadow-lg border" @keyup.enter="submit">

      <div class="text-2xl font-light text-gray-700">
        Forgot your password?
      </div>

      <div class="mt-6 leading-normal text-base">
        Please type in the email address you used to create
        a {{ getAppName }} account and we will email you with an
        instruction to reset your password.
      </div>

      <div class="mt-8">
        <input type="text"
          v-model="email"
          ref='email'
          class="input-standard"
          placeholder="Email"
          :disabled="loading" />

        <div v-if="errors.email !== null"
          class="text-red-500 mt-2 mb-4 text-sm">{{ errors.email }}</div>
      </div>

      <div class="mt-8">
        <button
          v-on:click="submit"
          class="text-white py-4 w-full bg-blue-500 font-semibold hover:bg-blue-500">
          <template v-if="loading"><img src="/static/img/ajax-loader.gif" class="inline" /></template>
          <template v-else>Submit</template>
        </button>
      </div>
    </div>

    <div class="pl-8 mt-6">
      <PublicFooter />
    </div>
  </div>
</template>

<script>

  import axios          from "axios";
  import validator      from "validator";
  import PublicFooter   from "@/shared/components/public/Footer"
  import BrokerpadLogo  from '@/shared/components/BrokerpadLogo'

  export default {

    components : {
      BrokerpadLogo,
      PublicFooter
    },

    mounted() {
      this.$refs.email.focus()
      document.body.className = 'bg-gray-100'
    },

    beforeDestroy() {
      document.body.className = ''
    },

    data () {
      return {
        loading: false,
        email  : null,

        errors: {
          email : null,
        },
      }
    },

    methods : {

      submit() {
        // validate
        let email = this.email;
        let valid   = true;

        // do we have a description?
        if(email == null || email.length == 0 || !validator.isEmail(email)) {
          this.errors.email = "Please type a valid email."
          valid = false;
        }

        if (valid) {
          this.loading = true;
          axios.post(process.env.VUE_APP_API_URL + '/api/auth/forgot-password', {
            email: this.email,
          }).then(response => {
            this.loading = false;
            this.$router.push('/auth/forgot-password-sent')
          }).catch(e => {
            this.loading = false;
            this.errors.email = e.response.data.error
          })
        }
      }
    },
  }
</script>